// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__IcbQ8","inputDescription":"styles_inputDescription__1LZPR"};